import {
  SectorsForAccruals,
  AccrualsSector,
} from 'constants/sectors-for-accruals';
import { IConstant } from 'types';

export const checkPayableStatus = (
  onLoad: boolean,
  AccrualsSectorType: IConstant[],
  getSectorData: (code: string) => number | undefined
): boolean => {
  if (!onLoad) {
    return !!AccrualsSectorType?.filter(
      (item: IConstant) =>
        SectorsForAccruals.includes(item.value as AccrualsSector) &&
        typeof getSectorData(item.value) === 'number' &&
        getSectorData(item.value)! > 0
    ).length;
  }

  return false;
};
